import type { ReactNode } from 'react';
import { AlertTriangle, RefreshCcw } from 'lucide-react';
import { getErrorMessage } from '@/lib/api';
import { Button } from '@/components/ui/Button';
import { EmptyState } from '@/components/ui/EmptyState';

export interface ErrorStateProps {
  error: unknown;
  onRetry?: () => void;
  title?: string;
}

export function ErrorState({ error, onRetry, title = 'Não foi possível carregar' }: ErrorStateProps) {
  return (
    <div className="surface-card">
      <EmptyState
        title={title}
        description={getErrorMessage(error)}
        icon={<AlertTriangle className="h-6 w-6 text-danger" />}
        action={
          onRetry ? (
            <Button variant="outline" size="sm" leftIcon={<RefreshCcw className="h-3.5 w-3.5" />} onClick={onRetry}>
              Tentar novamente
            </Button>
          ) : undefined
        }
      />
    </div>
  );
}

export interface QueryStateProps {
  isLoading: boolean;
  isError: boolean;
  error?: unknown;
  isEmpty?: boolean;
  onRetry?: () => void;
  loadingFallback: ReactNode;
  emptyFallback?: ReactNode;
  children: ReactNode;
}

/** Encadeia carregando → erro → vazio → conteúdo, sem repetir o padrão. */
export function QueryState({
  isLoading,
  isError,
  error,
  isEmpty,
  onRetry,
  loadingFallback,
  emptyFallback,
  children,
}: QueryStateProps) {
  if (isLoading) return <>{loadingFallback}</>;
  if (isError) return <ErrorState error={error} onRetry={onRetry} />;
  if (isEmpty && emptyFallback) return <>{emptyFallback}</>;
  return <>{children}</>;
}
